import { CommonModel } from '@telialt/models/src/CommonModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_PRODUCTS_SUGGESTIONS_COUNT, SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT } from '../../constants';
import { ProductSearchItem, SearchQueryKeysMap, SearchQueryParams } from '../../model';
import { getQueryKeyPrefixBySegment } from '../../utils/segment';

type Params = {
    searchText: string;
    segment: CommonModel.Segment;
    queryKeys: SearchQueryKeysMap;
    signal?: AbortSignal;
};

export const loadProductsSuggestions = async ({ searchText, segment, queryKeys, signal }: Params) => {
    const queryKeyPrefix = getQueryKeyPrefixBySegment(segment);

    const searchParams: SearchQueryParams = {
        searchText,
        offset: 0,
        limit: searchText ? SEARCH_PRODUCTS_SUGGESTIONS_COUNT : SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT,
    };

    try {
        const response = await apiGetSearchQuery<ProductSearchItem>(
            queryKeys[`${queryKeyPrefix}-products`],
            searchParams,
            signal,
        );

        return { products: response.data };
    } catch (error) {
        datadogLogger().warn(error, { component: DDComponent.Search });

        return { error };
    }
};
